var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body flex" }, [
        _c(
          "div",
          { staticClass: "form-group flex-grow-1" },
          [
            _c("label", [_vm._v("Препарат")]),
            _vm._v(" "),
            _c("DrugSearchNew", {
              ref: "selectedDrug",
              attrs: { onSelect: _vm.selectDrug },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Мин.Кол. зявок")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.minOrders,
                expression: "minOrders",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", placeholder: "Мин.Кол. зявок" },
            domProps: { value: _vm.minOrders },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.minOrders = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Кол. месяцев")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.months,
                expression: "months",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", placeholder: "Кол. месяцев" },
            domProps: { value: _vm.months },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.months = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex align_btn" },
          [
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                loading: _vm.loading,
                color: _vm.$constants.SUCCESS_COLOR,
                onClick: () => _vm.getData(1),
                className: "btn btn-outline-success btn-sm",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          [
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
            _vm._v(" "),
            !_vm.loading && _vm.records
              ? _c(
                  "table",
                  { staticClass: "table table-sm table-hover mt-1" },
                  [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _vm._v(" "),
                        _c("th", [_vm._v("ID")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Телефон")]),
                        _vm._v(" "),
                        _c("th", [
                          _c("i", {
                            class: {
                              "icon-fa pointer": true,
                              "icon-fa-sort-amount-asc":
                                _vm.sorting.firstOrder.direction === "asc",
                              "icon-fa-sort-amount-desc":
                                _vm.sorting.firstOrder.direction !== "asc",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.sortRecords("firstOrder")
                              },
                            },
                          }),
                          _vm._v("\n              Первая заявка\n            "),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("заявки")]),
                        _vm._v(" "),
                        _c("th", [
                          _c("i", {
                            class: {
                              "icon-fa pointer": true,
                              "icon-fa-sort-amount-asc":
                                _vm.sorting.lastOrders.direction === "asc",
                              "icon-fa-sort-amount-desc":
                                _vm.sorting.lastOrders.direction !== "asc",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.sortRecords("lastOrders")
                              },
                            },
                          }),
                          _vm._v(
                            "\n              Крайняя заявка\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("города")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Количество")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (r, i) {
                        return _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                i +
                                  1 +
                                  (_vm.paginator.current_page - 1) *
                                    _vm.paginator.per_page
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.phone_id))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.phone))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.printDate(
                                  r.first_date,
                                  "DD.MM.YYYY HH:mm",
                                  true
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openInNewPage("searchOrder", {
                                      ordersId: r.orders,
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                заявки (" +
                                    _vm._s(r.orders.length) +
                                    ")\n              "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.printDate(
                                  r.last_date,
                                  "DD.MM.YYYY HH:mm",
                                  true
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(Object.keys(r.cities), function (c) {
                              return _c("span", { staticClass: "mr-1" }, [
                                _vm._v(_vm._s(_vm.sortedCities[c]?.short_name)),
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(r.total_qty))]),
                        ])
                      }),
                      0
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.paginator
          ? _c(
              "div",
              { staticClass: "text-right" },
              [
                _c("paginate", {
                  attrs: {
                    "page-count": _vm.paginator.last_page,
                    "page-range": 10,
                    "margin-pages": 2,
                    "click-handler": _vm.getData,
                    "prev-text": "&laquo",
                    "next-text": "&raquo",
                    "container-class": "pagination",
                    "prev-class": "page-item",
                    "prev-link-class": "page-link",
                    "page-class": "page-item",
                    "page-link-class": "page-link",
                    "next-class": "page-item",
                    "next-link-class": "page-link",
                    "active-class": "active green_btn",
                  },
                  model: {
                    value: _vm.paginator.current_page,
                    callback: function ($$v) {
                      _vm.$set(_vm.paginator, "current_page", $$v)
                    },
                    expression: "paginator.current_page",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [
        _vm._v("Статистика продаж препарата (группировка по телефону)"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }